<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
var Env = process.env.NODE_ENV;
console.log(Env)
// if ( Env == 'development' ) {
//   return;
// }
import { getUrlParams } from "@/util/util";
import { setStore } from "@/util/store";
import { setToken } from '@/util/auth';
const WX_URL = "https://open.weixin.qq.com/connect/oauth2/authorize";
const APPID  = "wxbb9e82cfa9c913aa";
// const SCOPE  = "snsapi_base";
const SCOPE  = "snsapi_userinfo";
export default {
  data() {
    return {
    };
  },
  mounted() {
    const ua = navigator.userAgent.toLowerCase()
    const isWeixin = ua.indexOf('micromessenger') !== -1
    const url = `${WX_URL}?appid=${APPID}&redirect_uri=https://mmk.wepie.cc/tashan/Weixin/getWxUserInfo?backUrl=${encodeURIComponent(window.location.href)}&response_type=code&scope=${SCOPE}&state=STATE&connect_redirect=1#wechat_redirect`
    const token = getUrlParams('token');

    // 非开发环境时
    if ( Env != 'development' ) {
      if ( !isWeixin ) {
        window.location.href = url
      }
      if ( !token ) {
        window.location.href = url
      }
    }

    setStore({name: 'token', content: token});
    setToken(token);
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
@font-face {
  font-family: 'bmjh';
  src: url('./font/bmjh.ttf');
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: 'zpix';
  src: url('./font/zpix.ttf');
  font-weight: normal;
  font-style: normal;
}
/* 引入css样式 */
@import './assets/gka.css';
.comp-game-item {
  width: 170px !important;
  height: 344px !important;
  background-size: 100% auto !important;
}
</style>
